module.exports = __webpack_public_path__ + "img/ace2.4a29b779.jpg";